export const QtdeRegistrosDataTable = {
  
  QTDE: 10 as 10
  
}

